import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Button } from "react-bootstrap";
import axios from "axios";
import { getGlobals } from "../../Configs";
import SearchIcon from "@mui/icons-material/Search";
import { fAlertToast } from "../../Utility/Utilitys";
import './StockSetupChangeRequest.css';
const ItemSearchModal = ({
  open = false,
  handleClose = () => {},
  anyDataItemName = "",
  xMediaQuery = false,
  // setItemCode,
  // setItemName,
  countingItemName = "",
  location,
  handleItemRowClick = () => {},
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  let loader = document?.getElementById("loader") || {
    style: {
      display: "",
    },
  };
  const baseURL = getGlobals().API_BASE_URL;
  const [anyData, setAnyData] = useState("");
  const [itemNameSearch, setItemNameSaerch] = useState("");
  const [barCode, setBarCode] = useState("");
  const [refNo, setRefNo] = useState("");

  const [searchItemData, setSearchItemData] = useState([]);
  const [focusedRowIndex, setFocusedRowIndex] = useState(-1);
  const initialFetch = useRef(true);

  useEffect(() => {
    setAnyData(anyDataItemName || countingItemName);
  }, [anyDataItemName || countingItemName]);

  useEffect(() => {
    if (open) {
      if (initialFetch.current && anyData.length > 3) {
        getSearchItems();
        initialFetch.current = false;
      }
    } else {
      setSearchItemData([]);
      setItemNameSaerch("");
      setBarCode("");
      setRefNo("");
      initialFetch.current = true;
    }
  }, [open, anyData]);

  const handleAnyData = (e) => {
    setAnyData(e.target.value);
    if (e.target.value === "") {
      setSearchItemData([]);
    }
  };

  const handleItemName = (e) => {
    setItemNameSaerch(e.target.value);
    if (e.target.value === "") {
      setSearchItemData([]);
    }
  };
  const handleBarCode = (e) => {
    setBarCode(e.target.value);
    if (e.target.value === "") {
      setSearchItemData([]);
    }
  };
  const handleRefNo = (e) => {
    setRefNo(e.target.value);
    if (e.target.value === "") {
      setSearchItemData([]);
    }
  };

  const getSearchItems = async () => {
    // if (anyData.length <= 3) return;

    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/searchBKOrderItems`,
        {
          v_AnyData: anyData || "",
          v_Name1: itemNameSearch || "",
          v_Barcode: barCode || "",
          v_RefNo1: refNo || "",
          v_Loc: location,
        }
      );

      // Assuming response data structure is an array of objects
      if (response?.data) {
        setSearchItemData(response.data);
        loader.style.display = "none";
      }
    } catch (error) {
      setSearchItemData([]);
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "No records found";

      fAlertToast("FAILED", `${errorMessage}`);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown" && searchItemData.length > 0) {
      setFocusedRowIndex((prevIndex) => {
        const nextIndex =
          prevIndex + 1 < searchItemData.length ? prevIndex + 1 : 0;
        return nextIndex;
      });
    } else if (e.key === "ArrowUp" && searchItemData.length > 0) {
      setFocusedRowIndex((prevIndex) => {
        const nextIndex =
          prevIndex > 0 ? prevIndex - 1 : searchItemData.length - 1;
        return nextIndex;
      });
    } else if (e.key === "Enter") {
      if (focusedRowIndex !== -1) {
        handleItemRowClick(searchItemData[focusedRowIndex]);
        setTimeout(() => handleClose(), 80);
      } else {
        getSearchItems();
      }
    }
  };

  const handleClear = () => {
    setAnyData("");
    setItemNameSaerch("");
    setBarCode("");
    setRefNo("");
    setSearchItemData([]);

    setTimeout(() => {
      document.getElementById("anyDataDes").focus();
    }, 500);
  };

  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }} className="stock-detail">
      <Grid container spacing={2}>
        <Grid item xs={5.5} sm={5.5} md={5.5}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-input": {
                padding: "5px 8px !important",
                paddingRight: "0px !important",
              },
            }}
            fullWidth
            id="anyDataDes"
            label="Any Data"
            name="anyData"
            value={anyData}
            onKeyDown={handleKeyDown}
            onChange={handleAnyData}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={getSearchItems}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={5.5} sm={5.5} md={5.5}>
          <TextField
            fullWidth
            label="Item Name"
            name="itmName"
            value={itemNameSearch}
            onChange={handleItemName}
            autoComplete="off"
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={1} sm={1} md={1} display={"flex"}justifyContent={"flex-end"}textAlign={"flex-end"}>
        <Button
              sx={{
                height: "30px",
                mt: vMediaQuery || xMediaQuery ? 0 : 2,
                mr: 1,
                textTransform: "capitalize",
              }}
              onClick={getSearchItems}
            >
              Load
            </Button>
            </Grid>
        <Grid item xs={5.5} sm={5.5} md={5.5}>
          <TextField
            fullWidth
            label="Barcode"
            name="barCode"
            value={barCode}
            autoComplete="off"
            onChange={handleBarCode}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={5.5} sm={5.5} md={5.5}>
          <TextField
            fullWidth
            label="Ref.No"
            name="refNo"
            value={refNo}
            onChange={handleRefNo}
            onKeyDown={handleKeyDown}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={1} sm={1} md={1} display={"flex"}justifyContent={"flex-end"}textAlign={"flex-end"}>
        <Button
              sx={{
                height: "20px",
                mt: vMediaQuery || xMediaQuery ? 0 : 2,
                mr: 1,
                textTransform: "capitalize",
                fontSize: "14px !important",
              }}
              onClick={handleClear}
            >
              Clear
            </Button>
            </Grid>
      </Grid>

      <TableContainer
        component={Paper}
        className="table"
        sx={{
          height: vMediaQuery ? "35vh" : "40vh !important",
          marginTop: 2,
        }}
      >
        <Table
          size={vMediaQuery ? "small" : "medium"}
          sx={{
            "& .MuiTableCell-root": {
              textAlign: "left",
            },
          }}
          stickyHeader
        >
          <TableHead className="table-head" stickyHeader>
            <TableRow>
              <TableCell>Item Name</TableCell>
              <TableCell sx={{ width: "8%" }}>Ref No</TableCell>
              <TableCell sx={{ width: "12%" }}>BarCode</TableCell>
              <TableCell sx={{ width: "8%" }}>Selling Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {searchItemData.map((item, index) => (
              <TableRow
                key={index}
                onClick={() => handleItemRowClick(item)}
                sx={{
                  "& .MuiTableCell-root": {
                    backgroundColor:
                      focusedRowIndex === index ? "#f0f0f0" : "transparent",
                  },
                  "&:hover": {
                    backgroundColor: "#c4c4c424",
                  },
                }}
              >
                <TableCell>{item.Name1}</TableCell>
                <TableCell>{item.SuppRefNo1}</TableCell>
                <TableCell>{item.BarCode}</TableCell>
                <TableCell>{item.SellPr1}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid item xs={12} sm={12} md={12}>
     <Box sx={{ display: "flex", justifyContent: "space-around" }}>

       <Button
         sx={{
           height: "30px",
           mt: vMediaQuery || xMediaQuery ? 0 : 2,
           mr: 1,
           textTransform: "capitalize",
         }}
         onClick={handleClose}
       >
         Close
       </Button>
     </Box>
   </Grid>
    </Box>
  );
};

export default ItemSearchModal;
